(function () {
  function isCartPage() {
    return location.pathname === "/cart" || location.pathname.startsWith("/cart");
  }

  function removeDeliveryDateBlock() {
    const selectors = [
      ".nt-hide-delivery-date",
      ".cart__delivery-date",
      ".delivery-date",
      ".delivery_date",
      "[data-delivery-date]",
      "[data-cart-delivery-date]"
    ];
    selectors.forEach(sel => document.querySelectorAll(sel).forEach(el => el.remove()));

    document.querySelectorAll("h1,h2,h3,h4,legend,label,p,div,span").forEach(el => {
      const t = (el.textContent || "").trim().toLowerCase();
      if (!t) return;
      if (t.includes("datum isporuke") || t.includes("izaberite datum isporuke") || t.includes("datum isporuke:")) {
        const box = el.closest("section, .card, .box, .fieldset, form, .cart__footer, .cart__blocks, .shopify-section, div");
        if (box) box.remove();
      }
    });
  }

  function enhancePersonalizationPreviews() {
    // Cart template themes differ. We'll search for property links that contain data:image
    // and replace them with an <img> preview.
    const candidates = document.querySelectorAll("a, code, span, p, div, li");
    candidates.forEach(node => {
      const txt = (node.textContent || "").trim();
      if (!txt) return;

      // We only care about our new keys:
      // "Personalizacija - Mockup PNG (final)"
      // "Personalizacija - Upload PNG"
      // and values that look like data:image
      if (!txt.includes("data:image/")) return;

      // If it's already enhanced, skip
      if (node.closest(".nt-preview-wrap")) return;

      const dataUrlMatch = txt.match(/data:image\/[a-zA-Z0-9.+-]+;base64,[A-Za-z0-9+/=]+/);
      if (!dataUrlMatch) return;

      const dataUrl = dataUrlMatch[0];

      // Find the label near it (best effort)
      let label = "";
      const parentText = (node.parentElement && node.parentElement.textContent) ? node.parentElement.textContent : "";
      if (parentText.includes("Mockup PNG")) label = "Pregled (final)";
      else if (parentText.includes("Upload PNG")) label = "Učitana slika";
      else label = "Pregled";

      const wrap = document.createElement("div");
      wrap.className = "nt-preview-wrap";
      wrap.style.marginTop = "8px";
      wrap.style.display = "grid";
      wrap.style.gap = "6px";

      const lab = document.createElement("div");
      lab.textContent = label;
      lab.style.fontSize = "12px";
      lab.style.opacity = "0.8";
      lab.style.fontWeight = "700";

      const img = document.createElement("img");
      img.src = dataUrl;
      img.alt = label;
      img.style.maxWidth = "220px";
      img.style.width = "100%";
      img.style.height = "auto";
      img.style.borderRadius = "10px";
      img.style.border = "1px solid rgba(0,0,0,.12)";
      img.style.background = "rgba(0,0,0,.02)";

      // optional: click to open in new tab
      img.style.cursor = "zoom-in";
      img.addEventListener("click", () => {
        const w = window.open();
        if (w) {
          w.document.write(`<title>${label}</title><img src="${dataUrl}" style="max-width:100%;height:auto;" />`);
        }
      });

      wrap.appendChild(lab);
      wrap.appendChild(img);

      // Hide the original long base64 text (so cart doesn't look messy)
      const original = node.parentElement ? node.parentElement : node;
      original.style.display = "none";

      // Insert preview after original block
      (original.parentElement || node.parentElement || node).appendChild(wrap);
    });
  }

  async function run() {
    if (!isCartPage()) return;

    removeDeliveryDateBlock();
    enhancePersonalizationPreviews();

    // On quantity updates / ajax re-render
    const rerun = () => {
      removeDeliveryDateBlock();
      enhancePersonalizationPreviews();
    };

    document.addEventListener("change", (e) => {
      const t = e.target;
      if (!t) return;
      if (t.name && (t.name.includes("updates") || t.name.includes("quantity"))) {
        setTimeout(rerun, 400);
      }
    });

    document.addEventListener("cart:updated", () => {
      setTimeout(rerun, 200);
    });

    // Some themes replace cart via sections; run again a few times
    setTimeout(rerun, 600);
    setTimeout(rerun, 1400);
    setTimeout(rerun, 2400);
  }

  document.addEventListener("DOMContentLoaded", run);
})();
